import { Component, inject } from '@angular/core';
import { AppContainerService, AppConfiguration, SandboxPolicy } from '@app-container';
import { Config } from '@config';
import { AuthHttp, HttpTokenService } from '@http';
import { __i18n } from '@localisation';
import { MessagesService, MessageType } from '@ui-messages';
import { lastValueFrom } from 'rxjs';


@Component({
    selector: 'clx-node-red',
    templateUrl: './node-red.template.html',
    standalone: false
})
export class NodeRedComponent {
    containerService: AppContainerService = inject(AppContainerService);

    #configService: Config = inject(Config);
    #httpTokenService: HttpTokenService = inject(HttpTokenService);
    #http: AuthHttp = inject(AuthHttp);
    #messagesService: MessagesService = inject(MessagesService);
    
    config: AppConfiguration;
    isAvailable: boolean = false;

    async ngAfterViewInit() {
        const tokenObj = this.#httpTokenService.getToken();
        this.config = {
            name: 'Node Red',
            source: this.#configService.serverConfig.RULE_ENGINE_ACCESS_URL + '?access_token=' + tokenObj?.token,
            origin: '*',
            sandboxPrivileges : [
                SandboxPolicy['allow-scripts'],
                SandboxPolicy['allow-same-origin'],
                SandboxPolicy['allow-downloads'],
                SandboxPolicy['allow-popups']
            ]
        }

        try {
            const response = await lastValueFrom(this.#http.get(this.#configService.serverConfig.RULE_ENGINE_ACCESS_URL));
            this.isAvailable = response?.status === 200;
        } catch(ex) {
            this.isAvailable = false;
            
        }

        if(!this.isAvailable) {
            this.#messagesService.addMessage({
                target: 'node-red-unavailable-message',
                type: MessageType.error,
                text: 'The service you are trying to access is temporarily unavailable.'
            });
        }
    }
}